import { Injectable } from '@angular/core';
import {
  API_METHODS,
  API_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { SystemService } from '../../../core-services/system.service';
import { FormDataService } from '../../base-data-services/form-data.service';
import { SmApiService } from '../../../core-services/sm-api.service';
import { environment } from 'src/environments/environment';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { assingmentDetailsForm } from 'common/models/page-models/Assignments Model/assignments-form-meta.model';
import moment from 'moment';
import { data } from 'jquery';

@Injectable({
  providedIn: 'root',
})
export class AssignmentFormDataService extends FormDataService<AssignmentModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.addAssignment, http, ss);
  }
  override getUpdatePayload(data) {
    let payload;
    // console.log(data, '===');

    payload = {
      id: data.id,
    };
    return payload;
  }
  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.getAssignmentById,
      method: API_METHODS.post,
    };
    return edit;
  }

  postLoginData(data, url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService
        .postData(url, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  override convertFormData(body) {
    var formData: any = new FormData();
    Object.keys(body).forEach((a) => {
      formData.append(a.toString(), body[a]);
    });
    // console.log('PAYLOAD', formData);

    return formData;
  }

  // postAssignmentData(data, url: string): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.apiService
  //       .postData(url, this.convertFormData(data))
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }

  override async postData(data, isFormData: boolean = true): Promise<any> {
    return await super.postData(this.convertFormData(data), isFormData);
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<AssignmentModel> {
    return new Promise((resolve, reject) => {
      const submitData: any = new assingmentDetailsForm();
      submitData.topic = model.topic;
      submitData.description = model.description;
      submitData.type_id = model.type_id;
      submitData.category_id = model.category;
      submitData.trainer_id = model.trainer;
      submitData.batch_id = model.batch_id;
      // submitData.branch_id = model.branch_id;

      if (Array.isArray(model.branch_id)) {
        model.branch_id.forEach((id, index) => {
          submitData[`branchIds[${index}]`] = id;
        });
      }
      // submitData.group_id = model.group_id;
      if (Array.isArray(model.group_id)) {
        model.group_id.forEach((id, index) => {
          submitData[`groupIds[${index}]`] = id;
        });
      }
      submitData.assignment_email = model.emailID;
      // submitData.region = model.region;
      model.student_ids.forEach((studentId, index) => {
        submitData[`studentIds[${index}]`] = studentId;
      });
      submitData.upload_assignment_flag = model.uploadAssignment ? 1 : 0;
      if (model.addDescription) {
        submitData.upload_assignment_description = model.addDescription;
      }
      submitData.isEmailSendToTrainer = model.trigger_email ? 1 : 0;
      submitData.isTrainerDetailsShow = model.show_trainer_details ? 1 : 0;
      submitData.backDateAssignmentFlag = model.backDateAssignmentFlag ? 1 : 0;
      // submitData.branch_id = model.branch_id;
      if (model.id) {
        submitData.id = model.id;
      }
      submitData.location_id = model.location;
      model.achievementForm.forEach((item, index) => {
        submitData[`upload_document[${index}]`] = item;
      });

      // submitData.upload_document = model.achievementForm.map(item => item);

      // if (Array.isArray(model.achievementForm)) {
      //   submitData.upload_document = model.achievementForm.map(item => item); // This will create an array of the file objects
      // }

      // if (model.north) {
      //   submitData[`regionIds[0]`] = 1; 
      // }
      // if (model.south) {
      //   submitData[`regionIds[1]`] = 2; 
      // }
      // if (model.east) {
      //   submitData[`regionIds[2]`] = 3; 
      // }
      // if (model.west) {
      //   submitData[`regionIds[3]`] = 4; 
      // }

      const regionMap = metamodel.properties.regionIds.reduce((acc, region) => {
        acc[region.zone_name.toLowerCase()] = region.id;
        return acc;
      }, {});

      const regionIds = [];

      if (model.north) {
        regionIds.push(regionMap['north']);
      }
      if (model.south) {
        regionIds.push(regionMap['south']);
      }
      if (model.east) {
        regionIds.push(regionMap['east']);
      }
      if (model.west) {
        regionIds.push(regionMap['west']);
      }
      submitData['regionIds'] = regionIds;
      let selectedStudents = 0;
      let endDatesGreaterThanStartDate = 0;
      model.assingmentForm.forEach((item, index) => {
        // timeslot[0][start_date]
        // submitData[`timeslot[${index}][start_date]`] = item.start_date;
        if (item.end_date < item.start_date) {
          endDatesGreaterThanStartDate++;
        }
        submitData[`assignment_start_date[${index}]`] = moment(item.start_date).format('YYYY-MM-DD HH:mm');
        submitData[`assignment_end_date[${index}]`] = moment(item.end_date).format('YYYY-MM-DD HH:mm');
        submitData[`number_of_students[${index}]`] = item.noOfStudents;
        selectedStudents += Number(item.noOfStudents)
      });

      if (endDatesGreaterThanStartDate > 0) {
        this.systemService.showError('Due Date cannot be smaller than start date');
        return;
      }

      if (model.travelDocUploadEndDate < model.travelDocUploadStartDate) {
        this.systemService.showError('End Date should be greater than start date');
        return;
      }

      submitData.travelReimbursementFlag = model.travelReimbursementFlag ? 1 : 0;
      if (model.travelReimbursementFlag) {
        submitData.travelDocUploadStartDate = moment(model.travelDocUploadStartDate).format('YYYY-MM-DD HH:mm:ss');
        // submitData.travelDocUploadStartDate = model.travelDocUploadStartDate;
        submitData.travelDocUploadEndDate = moment(model.travelDocUploadEndDate).format('YYYY-MM-DD HH:mm:ss');
        // submitData.travelDocUploadEndDate = model.travelDocUploadEndDate;
        submitData.travelEmailDoc = model.travelEmailDoc;
      }
      // console.log('MODEl', model);
      // console.log('SUBMIT DATA', submitData);

      if (model.student_ids.length !== selectedStudents) {
        this.systemService.showError('Selected student and Timeslot student count must be same');
        return;
      }
      submitData.isgroup = Array.isArray(model.group_id) && model.group_id.length > 0 ? 1 : 0;
      console.log('SUBMIT DATA', submitData);
      resolve(submitData);
    });
  }

  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();
    dataModel.topic = response?.details?.topic;
    dataModel.type_id = response?.details?.type_id;
    dataModel.location = response?.details?.location_id;
    dataModel.category = response?.details?.category_id;
    dataModel.trainer = response?.details?.trainer_id;
    // console.log(dataModel.trainer);

    dataModel.emailID = response?.details?.assignment_email;
    dataModel.trigger_email = response?.details?.isEmailSendToTrainer === 1 ? true : false;
    dataModel.backDateAssignmentFlag = response?.details?.backDateAssignmentFlag === 1 ? true : false;
    dataModel.uploadAssignment = response?.details?.upload_assignment_flag === 1 ? true : false;
    dataModel.addDescription = response.details.upload_assignment_description;

    dataModel.show_trainer_details = response?.details?.isTrainerDetailsShow === 1 ? true : false;
    dataModel.description = response?.details?.description;
    dataModel.id = response?.details?.id;
    dataModel.batch_id = response?.details?.batch_id;

    dataModel.group_id = response?.details?.group_details?.map((group) => {
      return group ? group.id : null;
    });

    if (response?.details?.region_details) {
      response.details.region_details.forEach(region => {
        if (region) {
          if (region.zone_name === "North") {
            dataModel.north = "north";
          }
          if (region.zone_name === "South") {
            dataModel.south = "south";
          }
          if (region.zone_name === "East") {
            dataModel.east = "east";
          }
          if (region.zone_name === "West") {
            dataModel.west = "west";
          }
        }
      });
    }

    dataModel.assignmentDoc = response?.details?.assignmentDoc ? response.details.assignmentDoc : [];

    dataModel.branch_id = response?.details?.branch_details?.map((branch) => {
      return branch ? branch.id : null;
    }
    );

    dataModel.travelReimbursementFlag = response?.details?.travelReimbursementFlag === 1 ? true : false;

    if (response?.details?.travelReimbursementFlag === 1) {
      // dataModel.travelDocUploadStartDate = response?.details?.travelDocUploadStartDate ? this.formatDate(response.details.travelDocUploadStartDate) : "";
      dataModel.travelDocUploadStartDate = response?.details?.travelDocUploadStartDate ? new Date(response.details.travelDocUploadStartDate) : "";
      // dataModel.travelDocUploadEndDate = response?.details?.travelDocUploadEndDate ? this.formatDate(response.details.travelDocUploadEndDate) : "";
      dataModel.travelDocUploadEndDate = response?.details?.travelDocUploadEndDate ? new Date(response.details.travelDocUploadEndDate) : "";
      dataModel.travelEmailDoc = response?.details?.travelEmailDoc ? response.details.travelEmailDoc : "";
    }

    // dataModel.branch_id = response?.assignment_department_detail?.map((a) => {
    //   return a.department_id;
    // });
    //   this.selectedGroups = this.assignment.group_id;
    // dataModel.group_id = response?.assignment_group_detail.map((a) => {
    //   console.log(dataModel.group_id)
    //   return a.group_id;
    // });
    dataModel.student_ids = response?.details?.student_details
      ? response.details.student_details.map((a) => a.id)
      : [];

    dataModel.time = response?.details.timeslot_info?.map((item, index) => {
      return {
        start_date: moment(item[`start_date`], "DD-MM-YYYY hh:mm A").toISOString(),
        end_date: moment(item[`end_date`], "DD-MM-YYYY hh:mm A").toISOString(),
        noOfStudents: item[`number_of_student`],
      };
    });

    // response['details']['west']='',
    // response['details']['north']=''
    // response['details']['south']=''
    //   response['details']['east']=''
    // dataModel.batch_id=response.ass
    return dataModel;
  }

  formatDate(dateValue) {
    if (!dateValue || dateValue === 0) {
      return '';
    }
    const formattedDate = moment(dateValue).format('DD/MM/YYYY');
    return moment(formattedDate, 'DD/MM/YYYY').isValid() ? formattedDate : '';
  }

  createInstance(): AssignmentModel {
    return new AssignmentModel();
  }

  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    return environment.apiUrl + this.getAPI_URL();
  }
}

export { FormDataService };
